import React, { useEffect } from 'react';
import MenuItem from './MenuItem';
import styles from './styles.module.scss';
import { MenuList } from '../../../types/menu';
import useLocalStorage from '../../../hooks/useUserData';

interface MenusProps {
  menuList: MenuList[];
}

const Menus: React.FC<MenusProps> = ({ menuList }) => {
  return (
    <div className={styles['menus-container']}>
      {menuList.map((item, index) => (
        <MenuItem key={index} item={item} />
      ))}
    </div>
  );
};

export default Menus;
